/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import AppDownload from "./AppDownload";
import FeaturesBar from "./FeaturesBar";
import UserCredentials from "./UserCredentials";
import OtpVerification from "./OtpVerification";
import PinVerification from "./PinVerification";
import LinkToKyc from "./LinkToKyc";

export {
  AppDownload,
  FeaturesBar,
  UserCredentials,
  OtpVerification,
  PinVerification,
  LinkToKyc
};
